import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import { getCircular } from "../Service/Api";
import { buildSyllabusByTab, pdfHref } from "../utils/syllabusStage";

const tabs = [
  "PT-1",
  "PT-2",
  "Half Yearly Examination",
  "PT-3",
  "Annual Examination",
];
const CATEGORY = "PreparatoryStageSyllabus";

const CLASS_RANK = {
  class3: 0,
  classiii: 0,
  class4: 1,
  classiv: 1,
  class5: 2,
  classv: 2,
};

const emptyTabs = () => Object.fromEntries(tabs.map((name) => [name, []]));

function PreparatoryStage() {
  const [tab, setTab] = useState("PT-1");
  const [syllabusByTab, setSyllabusByTab] = useState(emptyTabs);

  useEffect(() => {
    document.title =
      "Preparatory Stage (III–V) - St Peters Convent School Faridabad Haryana";
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getCircular();
        setSyllabusByTab(buildSyllabusByTab(data, CATEGORY, tabs, CLASS_RANK));
      } catch (error) {
        console.error("Error fetching syllabus:", error);
      }
    };
    fetchData();
  }, []);

  const syllabusItems = syllabusByTab[tab] || [];

  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>Academics</li>
          <li>Syllabus</li>
          <li>Preparatory Stage (III–V)</li>
        </ul>
      </div>

      <div className="innersec">
        <div className="container">
          <div className="row mb-4">
            <div className="col-12">
              <h1 className="fw-bold">Preparatory Stage (III–V)</h1>
            </div>
          </div>

          <nav>
            <div className="nav nav-tabs" role="tablist">
              {tabs.map((name) => (
                <button
                  key={name}
                  type="button"
                  role="tab"
                  className={`nav-link${tab === name ? " active" : ""}`}
                  aria-selected={tab === name}
                  onClick={() => setTab(name)}
                >
                  {name}
                </button>
              ))}
            </div>
          </nav>

          <div className="row mt-4">
            {syllabusItems.map((item) => (
              <div className="col-lg-3 col-md-6 mb-4" key={item.fileName}>
                <div className="card syllabus-card h-100 text-center">
                  <div className="card-body">
                    <div className="pdf-icon mb-3">📄</div>
                    <h6 className="fw-semibold">{item.classLabel}</h6>
                    <a
                      href={pdfHref(item.fileName)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="click-text"
                    >
                      Click Here →
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default PreparatoryStage;
